import { AxiosResponse } from 'axios'
import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'
import { RequestREAD } from 'services/Instances'
import jwt from 'jsonwebtoken'
import useAuth from 'hooks/useAuth'

export function ReportsCREServices(user) {


  const path = 'RelatorioCRE'
  const idUsuario = user?.IdUsuario;
  const idPerfil = user?.PerfilUsuarioId;
  const urlCards = `${path}/FillCardsRelatorioCRE?idUsuario=${idUsuario}&idPerfil=${idPerfil}`
  const urlFinalResult = `${path}/RelatorioFinal?idUsuario=${idUsuario}&idPerfil=${idPerfil}`;
  const urlFinalExcel = `${path}/RelatorioExcel?idUsuario=${idUsuario}&idPerfil=${idPerfil}`;
  const urlFinalPDF = `${path}/RelatorioPDF?idUsuario=${idUsuario}&idPerfil=${idPerfil}`;
  const getCards = async (
    request: IRequestCards
  ): Promise<AxiosResponse<IResponseCards>> =>
    await RequestREAD.post(urlCards, request)

  const getEndResult = async (
    request: IParamsEndResult
  ): Promise<AxiosResponse<IResponseEndResult>> =>

    await RequestREAD.post(urlFinalResult, request, {
      timeout: 99999999999,
      timeoutErrorMessage: 'Tempo de consulta excedido.'
    })

  const getExcelResult = async (
    request: IParamsEndResult
  ): Promise<AxiosResponse<string>> =>
    await RequestREAD.post(urlFinalExcel, request, {
      timeout: 99999999999,
      timeoutErrorMessage: 'Tempo de consulta excedido.'
    })

  const getPDFResult = async (
    request: IParamsEndResult
  ): Promise<AxiosResponse<string>> =>
    await RequestREAD.post(urlFinalPDF, request, {
      timeout: 99999999999,
      timeoutErrorMessage: 'Tempo de consulta excedido.'
    })

  return {
    getCards,
    getEndResult,
    getExcelResult,
    getPDFResult
  }
}

export interface IRequestCards {
  flPaginacao?: boolean
  pageNumber?: number
  pageSize?: number
  cdMatricula?: string
  periodoEntradaIni?: string | Date | null
  periodoEntradaFim?: string | Date | null
  competenciaDataIni?: string | Date | null
  competenciaDataFim?: string | Date | null
  cdContrato?: string
  nmFornecedor?: string
  nmEmpresa?: string
  nmCentro?: string
  unidadeGestoraId?: IOnChangeUnidadeGestora
  flLiberado?: boolean
  flPrescricao?: boolean
  flDocPostado?: boolean
  nmSubcontratada?: string
  flDenuncia?: boolean
  contratosIds?: number[] | []
  fornecedoresIds?: number[] | []
  empresasIds?: number[] | []
  centrosIds?: number[] | []
  subcontratadasIds?: number[] | []
}

interface IResponseInfo {
  sucesso: boolean
  mensagem: string | null | any
  detalhe: string | null | any
  tipo: string | null | any
}
interface ICard {
  id: number
  name: string
  checked: boolean
}

export interface IResponseCardsEntity {
  contratos: ICard[]
  fornecedores: ICard[]
  empresas: ICard[]
  centros: ICard[]
  subFornecedores: ICard[]
}

export interface IResponseCards extends IResponseInfo {
  entity: IResponseCardsEntity
}

export interface RequestGetVisualizar {
  dataIni?: Date
  dataFim?: Date
  contratosIds: number[]
}

type IParamsEndResult = IRequestCards

export interface IResponseResultGroupsItems {
  FORMAT: any
  dataLiberacaoMovDocumento: string
  tipoPendencia: string
  vlRisco: number
  txPendencia: string | null
  dtLiberacao: string | null
  cdMatriculaItem: string | null
  qtDiasCriacaoDocumento: number
  flDocPostado: string
  dtAnexo: string | null
}

interface IResponseResultGroupsCabecalho {
  cdContrato: string
  nmFornecedor: string
  nmSubContratada: string
  dtContratoIni: Date | string | null
  dtContratoFim: Date | string | null
  de: string | null
  dir: string | null
  gg: string | null
  ger: string | null
  nmAnalista: string
  cdMatricula: string
  cdCRE: string | null
  dtVerificacao: string | null
  dtEntrada: Date | string | null
  dtRetorno: Date | string | null
  qtDiasBloqueio: string | null
  qtTotalEfetivos: string | null
}
export interface IResponseResultGroups {
  cabecalho: IResponseResultGroupsCabecalho
  itens: IResponseResultGroupsItems[]
}

interface IResponseResultTotals {
  qtPendencias: number
  qtPendenciasResolvidas: number
  vlRisco: number
  vlRiscoEvitado: number
}

export interface IResponseEndResultEntity {
  titulo: string
  currentPage: number
  totalItensPaginated: number
  subTitulo: string
  grupos: IResponseResultGroups[]
  totalTrabalhista: IResponseResultTotals
  totalPrevidenciario: IResponseResultTotals
  totalOutros: IResponseResultTotals
  totalGeral: IResponseResultTotals
}
export interface IResponseEndResult extends IResponseInfo {
  entity: IResponseEndResultEntity
}
